// src/hooks/useTypewriter.js
import { useEffect, useRef, useState } from 'react';

/**
 * Types a string character-by-character.
 * @param {string} text  - full string to type
 * @param {boolean} start - when true, typing begins
 * @param {number} speed - ms per character
 * @returns {{ typed: string, isDone: boolean }}
 */
export function useTypewriter(text, start = true, speed = 60) {
  const [typed, setTyped] = useState('');
  const iRef = useRef(0);

  useEffect(() => {
    if (!start) {
      setTyped('');
      iRef.current = 0;
      return;
    }
    iRef.current = 0;
    setTyped('');
    const id = setInterval(() => {
      iRef.current += 1;
      setTyped(text.slice(0, iRef.current));
      if (iRef.current >= text.length) clearInterval(id);
    }, speed);
    return () => clearInterval(id);
  }, [text, start, speed]);

  return { typed, isDone: typed.length === text.length };
}
